import React from 'react';
// import Select from 'react-select';
// import GridActions from './action/gridActions';
// import BuildActions from '../builder/action/builderActions';
// import { findIndex } from 'underscore';
// import clone from 'clone';
// import GridStore from './store/gridStore';
// import classNames from 'classnames';
// import ImageSelect from '../element/imageselect';


class UserPanel extends React.Component {
    render() {
      return (<div className="">
        <p>this is user panel </p>
      </div>);
    }

}

export default UserPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/userPanel.js
 **/